import { MarginProps, styledMargin } from '@tink/core/src/components/atoms/Margins/margins';
import { Sizes } from 'styled-components';
import { ConfigurationColors } from '@tink/config/src/tinkLinkConfig';
import { styled } from '../../../core/theme/styled';

export type FormLabelProps = {
  color?: keyof ConfigurationColors;
  size?: 'inherit' | Sizes;
} & MarginProps;

export const FormLabel = styled.label<FormLabelProps>`
  color: ${({ color, theme }) =>
    color ? theme.configuration[color] : theme.configuration.primaryTextColor};
  display: inline-block;
  font-size: ${(props) =>
    props.size === 'inherit' ? 'inherit' : props.theme.sizes[props.size || 'normal']};
  ${styledMargin}
`;
